
// base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
function dataURLtoFile(dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], { type: mime })
}

// 压缩图片
function compressImg(file) {
  // var src
  var files
  var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2)
  if (fileSize < 1) {
    return new Promise(function(resolve, reject) {
      resolve(file)
    })
  } else {
    var read = new FileReader()
    read.readAsDataURL(file)
    return new Promise(function(resolve, reject) {
      read.onload = function(e) {
        var img = new Image()
        img.src = e.target.result
        img.onload = function() {
          // 默认按比例压缩
          var w = this.width
          var h = this.height
          // 生成canvas
          var canvas = document.createElement('canvas')
          var ctx = canvas.getContext('2d')
          var base64
          // 创建属性节点
          canvas.setAttribute('width', w)
          canvas.setAttribute('height', h)
          ctx.drawImage(this, 0, 0, w, h)
          if (fileSize > 1 && fileSize < 2) {
            console.info('图片压缩，比例0.8')
            // 如果图片大于1M并且小于2M 那么压缩0.5
            base64 = canvas.toDataURL(file['type'], 0.7)
          } else {
            // 如果图片超过2m 那么压缩0.2
            console.info('图片压缩，比例0.55')
            base64 = canvas.toDataURL(file['type'], 0.5)
          }
          // 回调函数返回file的值（将base64编码转成file）
          files = dataURLtoFile(base64) // 如果后台接收类型为base64的话这一步可以省略

          resolve(files)
        }
      }
    })
  }
}

var Tiff = require('tiff.js')

/**
* 将tiff文件转化
* @param  {String} 文件名 目标文件地址
* @param  {String} filename 想要保存的文件名称
*/
function getTif({ url, w, h, isScale }) {
  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest()
    xhr.responseType = 'arraybuffer'
    xhr.open('GET', url.replace('http', 'https'))
    xhr.onload = function(e) {
      var tiff = new Tiff({ buffer: xhr.response })
      var canvas = tiff.toCanvas()
      var width = tiff.width()
      var height = tiff.height()
      var scale = 1
      if (canvas) {
        // 设置宽高 width: 560px; height: 300px; 等比例缩放图片
        if (isScale) {
          if (width > w || height > h) {
            if (width > height) {
              scale = w / width
            } else {
              scale = h / height
            }
          }
          canvas.setAttribute('style', 'width:' + (width * scale) +
            'px; height: ' + (height * scale) + 'px; border-radius:5%')
        } else {
          if (width > 1200) {
            width = 1200
          }
          canvas.setAttribute('style', 'width:' + width + 'px;')
        }

        resolve(canvas)
      } else {
        resolve()
      }
    }
    xhr.send()
  })
}

// function decodeBase64(base64Str) {
//   var bString = atob(base64Str)
//   var len = bString.length
//   var arr = new Uint8Array(len)
//   while (len--) {
//     arr[len] = bString.charCodeAt(len)
//   }
//   return arr
// }

function hasTiff(url) {
  let flag = false
  if (url.substr(-4).includes('tiff') || url.substr(-3).includes('tif')) {
    flag = true
  }

  return flag
}

// 结尾处将该方法暴露出来供外部调用
export default {
  compressImg, hasTiff, getTif
}
